import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Keyboard, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./GalleryTab.css";

import slide1  from '../images/bushfield.jpg';
import slide2  from '../images/crab-wood.jpg';
import slide3  from '../images/dieback.jpg';
import slide4  from '../images/valley-of-the-rocks.jpg';
import slide5  from '../images/watchers.jpg';
import slide6  from '../images/eidfjord.jpg';
import slide7  from '../images/honister-pass.jpg';
import slide8  from '../images/evening-on-the-exe.jpg';
import slide9  from '../images/the-last-beech.jpg';
import slide11 from '../images/ups-and-downs.jpg';
import slide12 from '../images/frosty-morning.jpg';
import slide13 from '../images/one-more-to-go.jpg';
import slide14 from '../images/alpine-tranq-full.jpg';
import slide15 from '../images/still-in-alesund.jpg';
import slide16 from '../images/welsh-track.jpg';
import slide17 from '../images/tyrol.jpg';
import slide18 from '../images/sentinel.jpg';

const images = [
  {
    src: slide1,
    caption: 'Bushfield Camp',
    description: 'Acrylic on canvas 40 x 30cm unframed £250',
  },
  {
    src: slide2,
    caption: 'Autumn in Crab Wood',
    description: 'Acrylic on canvas 40 x 30cm unframed £250',
  },
  {
    src: slide3,
    caption: 'Dieback',
    description: 'Acrylic on canvas 40 x 30cm unframed £300',
  },
  {
    src: slide4,
    caption: 'Valley of the Rocks',
    description: 'Acrylic on paper 68.5cm x 53.5cm including mount and frame £375',
  },
  {
    src: slide5,
    caption: 'Watchers',
    description: 'Acrylic on paper 52cm x 70cm including mount and frame £400',
  },
  {
    src: slide6,
    caption: 'Eidfjord',
    description: 'Acrylic on box canvas, 20cm x 25.5cm x 4cm unframed £100',
  },
  {
    src: slide7,
    caption: 'Honister Pass',
    description: 'Acrylic on canvas 40 x 30cm unframed £250',
  },
  {
    src: slide8,
    caption: 'An evening on the Exe',
    description: 'Acrylic on canvas 51cm x 40cm unframed £300',
  },
  {
    src: slide9,
    caption: 'The Last Beech',
    description: 'Acrylic on box canvas 42cm x 30cm x 4cm unframed £300',
  },
  {
    src: slide11,
    caption: 'Ups and Downs',
    description: 'Acrylic on canvas 30cm x 20cm unframed £100',
  },
  {
    src: slide12,
    caption: 'Frosty morning',
    description: 'Acrylic on approx A4 canvas £100',
  },
  {
    src: slide13,
    caption: 'One more to go',
    description: 'Acrylic on canvas 40cm x 30cm £400',
  },
  {
    src: slide14,
    caption: 'Alpine Tranquility',
    description: 'Acrylic on canvas 61cm x 46cm £600',
  },
  {
    src: slide15,
    caption: 'Still in Alesund II',
    description: 'Acrylic on canvas. 40.5cm x 30.5cm unframed £250',
  },
  {
    src: slide16,
    caption: 'Welsh Track',
    description: 'Acrylic on canvas. 20cm x 30cm unframed £100',
  },
  {
    src: slide17,
    caption: 'Tyrol',
    description: 'Acrylic on canvas. 20cm x 50cm unframed £200',
  },
  {
    src: slide18,
    caption: 'Sentinel',
    description: 'Acrylic on canvas. 20cm x 30cm unframed £80',
  },
];

export default function Gallery() {
  return (
    <main>
      <Swiper
        modules={[Navigation, Keyboard, Pagination]}
        navigation
        keyboard={{ enabled: true }}
        spaceBetween={30}
        slidesPerView={1}
        loop={true}
        className="gallery-swiper"
      >
        {images.map((img, idx) => (
          <SwiperSlide key={img.src}>
            <figure className="gallery-slide">
              <img
                src={img.src}
                alt={img.caption}
                className="gallery-img"
                draggable={false}
              />
              <figcaption>
                <strong>{img.caption}</strong>
                <div className="desc">{img.description}</div>
              </figcaption>
            </figure>
          </SwiperSlide>
        ))}
      </Swiper>
    </main>
  );
}
